var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.285156 2.14419L4.64177 6.49992L0.285156 10.8556L2.15656 12.7271L8.38281 6.49992L2.15656 0.27278L0.285156 2.14419Z","fill":"white","stroke":"white"}));
}

ChevronRightInline.defaultProps = {"width":"9","height":"13","viewBox":"0 0 9 13","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
